import {Component, Input} from '@angular/core';
import {IconComponent} from "../icon/icon.component";
import {Icon, Icons} from "../../../model/icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-button-icon',
  imports: [
    IconComponent,
    NgIf
  ],
  templateUrl: './button-icon.component.html',
  styleUrl: './button-icon.component.scss'
})
export class ButtonIconComponent {
    @Input() active: boolean = false;
    @Input() icon?: Icon;
    @Input() invert?: number;
    @Input() title?: string = 'Все места';
  protected readonly Icons = Icons;
}
